<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="仓库">
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="库区">
						<el-select filterable v-model="searchInfo.districtId" style="width: 200px" placeholder="请选择" clear 
						>
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseAreaName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="库位编码" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.warehouseLocationName" placeholder="请输入库位编码">
						</el-input>
					</el-form-item>
                  
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
            <el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="120px">
						<el-form-item label="最大体积(m³)">
							<span>{{props.row.warehouseLocationVolume}}</span>
						</el-form-item>						
						<el-form-item label="最大重量(t)">
							<span>{{props.row.warehouseLocationWeight}}</span>
						</el-form-item>
						<el-form-item label="库位长度(m)">
							<span>{{props.row.warehouseLocationLength}}</span>
						</el-form-item>
						<el-form-item label="库位宽度(m)">
							<span>{{props.row.warehouseLocationWidth}}</span>
						</el-form-item>
						<el-form-item label="备注">
							<span>{{props.row.memo}}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="warehouseName" label="仓库" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="warehouseAreaName" label="库区" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="warehouseLocationName" label="库位编码" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="warehouseLocationCode" label="库位名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="warehouseLocationType" label="库位种类" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.warehouseLocationType==1" >平面仓库位</span>
					<span v-if="scope.row.warehouseLocationType==2" >货架仓库位</span>
					<span v-if="scope.row.warehouseLocationType==3" >高架仓库位</span>
					<span v-if="scope.row.warehouseLocationType==4" >重力式货架库位</span>
					<span v-if="scope.row.warehouseLocationType==5" >堆垛机货架库位</span>
					<span v-if="scope.row.warehouseLocationType==6" >后推式库位</span>
					<span v-if="scope.row.warehouseLocationType==7" >8进深驶入式</span>
					<span v-if="scope.row.warehouseLocationType==8" >12进深驶入式</span>
				</template>
			</el-table-column>
            <el-table-column prop="useType" label="使用类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.useType==1" >件拣货库位</span>
					<span v-if="scope.row.useType==2" >箱拣货库位</span>
					<span v-if="scope.row.useType==3" >箱件合并拣货库位</span>
					<span v-if="scope.row.useType==4" >存储库位</span>
					<span v-if="scope.row.useType==5" >收货过渡库位</span>
					<span v-if="scope.row.useType==6" >备货库位</span>
					<span v-if="scope.row.useType==7" >品质库位</span>
					<span v-if="scope.row.useType==8" >加工台</span>
					<span v-if="scope.row.useType==9" >过渡库位</span>
					<span v-if="scope.row.useType==10" >小库位</span>
				</template>
			</el-table-column>
            <!-- <el-table-column prop="warehouseLocationVolume" label="最大体积(立方米)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="warehouseLocationWeight" label="最大重量(kg)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="warehouseLocationLength" label="库位长度(m)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="warehouseLocationWidth" label="库位宽度(m)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->

		    <el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#F56C6C;font-weight: bold;">停用</span>
					<span v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="memo" label="备注" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="createBy" label="创建人"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateBy" label="修改人"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="updateTime" label="修改时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="100px">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<!-- <el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button> -->
					<el-button size="small" type="text" style="color:red;" @click="toBlockUp(scope.row.id)"  
					v-if="scope.row.status==1">停用</el-button> 

					<el-button size="small" type="text" style="color:#67C23A;" @click="toStartUsing(scope.row.id)"
					 v-if="scope.row.status==0">启用</el-button> 
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="poupTitle+'仓库库位'" @close="addDialogClose"
			:close-on-click-modal="false" width="600px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
                    <el-form-item label-width="120px"  label="仓库">
						<el-select filterable v-model="warehouseId" style="width: 300px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label-width="120px"  label="库区">
						<el-select filterable v-model="districtId" style="width: 300px" placeholder="请选择" clear 
						>
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseAreaName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="库位编码" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationName"
							auto-complete="off" placeholder="库位编码" />
					</el-form-item>
					<el-form-item label="库位名称" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationCode"
							auto-complete="off" placeholder="库位名称" />
					</el-form-item>
                    <el-form-item label-width="120px"  label="库位种类">
						<el-select filterable v-model="storeGoodsInfo.warehouseLocationType" style="width: 300px" placeholder="请选择" clear 
						>
							<el-option key="0" :value="1" label="平面仓库位"></el-option>
							<el-option key="1" :value="2" label="货架仓库位"></el-option>
							<el-option key="2" :value="3" label="高架仓库位"></el-option>
							<el-option key="3" :value="4" label="重力式货架库位"></el-option>
							<el-option key="4" :value="5" label="堆垛机货架库位"></el-option>
							<el-option key="5" :value="6" label="后推式库位"></el-option>
							<el-option key="6" :value="7" label="8进深驶入式"></el-option>
							<el-option key="7" :value="8" label="12进深驶入式"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label-width="120px"  label="使用类型">
						<el-select filterable v-model="storeGoodsInfo.useType" style="width: 300px" placeholder="请选择" clear 
						>
							<el-option key="0" :value="1" label="件拣货库位"></el-option>
							<el-option key="1" :value="2" label="箱拣货库位"></el-option>
							<el-option key="2" :value="3" label="箱件合并拣货库位"></el-option>
							<el-option key="3" :value="4" label="存储库位"></el-option>
							<el-option key="4" :value="5" label="收货过渡库位"></el-option>
							<el-option key="5" :value="6" label="备货库位"></el-option>
							<el-option key="6" :value="7" label="品质库位"></el-option>
							<el-option key="7" :value="8" label="加工台"></el-option>
							<el-option key="8" :value="9" label="过渡库位"></el-option>
							<el-option key="9" :value="10" label="小库位"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="最大体积" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationVolume"
							auto-complete="off" placeholder="最大体积" >
                            <template slot="append">m³</template>
						</el-input>
					</el-form-item>
                    <el-form-item label="最大重量" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationWeight"
							auto-complete="off" placeholder="最大重量" >
                            <template slot="append">t</template>
						</el-input>
					</el-form-item>
                    <!-- <el-form-item label="库位长度" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationLength"
							auto-complete="off" placeholder="库位长度" >
                            <template slot="append">m</template>
						</el-input>
					</el-form-item> -->
                     <el-form-item label="库位长宽" label-width="120px">
						<el-input type="text" style="width: 150px;" v-model="storeGoodsInfo.warehouseLocationLength"
							auto-complete="off" placeholder="库位长度" >
                            <template slot="append">m</template>
						</el-input>
						<el-input type="text" style="width: 150px;" v-model="storeGoodsInfo.warehouseLocationWidth"
							auto-complete="off" placeholder="库位宽度" >
                            <template slot="append">m</template>
						</el-input>
					</el-form-item>
					<el-form-item label="是否启用" class="redItem" label-width="120px">
						<el-switch v-model="storeGoodsInfo.status"  :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
                    <el-form-item label="备注" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.memo"
							auto-complete="off" placeholder="请输入备注" />
					</el-form-item>
                    <div style="height:20px"></div>
					<el-button type="primary" @click="submit" v-if="poupTitle=='新增'" :loading="addLoading">提交</el-button>
					<el-button type="primary" @click="submitClick" v-if="poupTitle=='编辑'" :loading="editLoading">提交</el-button>
				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,
                // dialogVisibleSwipers: false
                poupTitle: '',
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                districtId: '',
                locationList: [],
                warehouseList: [],

			}
		},
		methods: {
			//导出
			downloadFile() {
				let data = {
					warehouseLocationName:this.searchInfo.warehouseLocationName,
                    warehouseId: this.searchInfo.warehouseId,
                    warehouseAreaId: this.searchInfo.districtId
				};
				// console.log(data);
				this.$api.wmsWarehouseLocationListExportExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "库位管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.searchInfo = {}

			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
                    warehouseLocationName:this.searchInfo.warehouseLocationName,
                    warehouseId: this.searchInfo.warehouseId,
                    warehouseAreaId: this.searchInfo.districtId
				}
				this.$api.getWarehouseLocationList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

            },
            warehouseFocus(e){
                this.$api.getDistrictListNoParameter({
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
            },
			// 新增
			addCarousel() {
                this.storeGoodsInfo = {};
                this.poupTitle = '新增';
                this.warehouseId = '';
                this.districtId = '';
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
                // let data = this.storeGoodsInfo
                this.addLoading = true;
				let data = {
                    warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo
				}
				// console.log(data)
				this.$api.addWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.addLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
                // console.log(e)
                this.storeGoodsInfo = {};
                this.warehouseId = '';
                this.districtId = '';
                this.poupTitle = '编辑';
				this.$api.getWarehouseLocationInfoByID(e).then((res) => {
					if (res.state == 'success') {
                        this.storeGoodsInfo = res.data;
                        this.warehouseId =  res.data.warehouseId;
                        this.districtId = res.data.warehouseAreaId;
                        this.storeGoodsInfo.status = res.data.status == 1 ? true : false;
                        this.warehouseFocus(res.data.warehouseId)
						this.dialogVisibleSwiper = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
                this.editLoading = true;
                // let data = this.storeGoodsInfo
                let data = {
					 warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo,

                    id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.editLoading = false;
				})

			},
			// 停用
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将停用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 启用
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将启用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            getWarehouseLis(){
                this.$api.getWarehouseListNoParameter({
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.warehouseList = res.data
					}
				})
            },
		},




		created() {
			this.findPmsUnit()
            this.getWarehouseLis()
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
</style>
